import { render, staticRenderFns } from "./traMediciWaring.vue?vue&type=template&id=92c414b4&scoped=true"
import script from "./traMediciWaring.vue?vue&type=script&lang=js"
export * from "./traMediciWaring.vue?vue&type=script&lang=js"
import style0 from "./traMediciWaring.vue?vue&type=style&index=0&id=92c414b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c414b4",
  null
  
)

export default component.exports